export default "__VITE_ASSET__MlYxAx2P__"